import React from "react";

function Product() {
  return (
    <section className="product-sec product-ro">
      <div className="columns  ">
        <div className="column ">
          <img src="./img/product.png" alt="product-temp" className="" />
        </div>
        <div className="column">
          <img src="./img/product.png" alt="product-temp" className="" />
        </div>
        <div className="column">
          <img src="./img/product.png" alt="product-temp" className="" />
        </div>
      </div>
    </section>
  );
}

export default Product;
